import React, { useState } from "react";
import { Dialog, DialogPanel, DialogTitle } from "@headlessui/react";
import { IoClose, IoSearchOutline } from "react-icons/io5";
import { RxCross2 } from "react-icons/rx";
import { useAppDispatch, useAppSelector } from "../../../utils/hooks";
import { updateCreateGroupData } from "../../../store/Slices/CreateGroupSlice";
import AddMemberContactList from "../Contacts/AddMemberContactList";
import { useTranslateText } from "../../../hooks/useTranslateText";
import TextTranslate from "../../../utils/TextTranslate";

const AddMemberModal: React.FC = () => {
  const CreateGroup = useAppSelector((state) => state.CreateGroup);
  const dispatch = useAppDispatch();
  const translate = useTranslateText();
  const [searchUser, setsearchUser] = useState("");

  const handleCloseModal = () => {
    setsearchUser("");
    dispatch(
      updateCreateGroupData({
        show_add_member_modal: false,
        existing_member_user_id: [],
        user_id: [],
      }),
    );
  };

  const selectedCount = CreateGroup.user_id.length;

  return (
    <Dialog
      open={CreateGroup.show_add_member_modal}
      onClose={handleCloseModal}
      className="relative z-[100]"
    >
      <div className="fixed inset-0 bg-black/40 backdrop-blur-sm">
        <div className="flex min-h-full items-end justify-center p-0 sm:items-center sm:p-4">
          <DialogPanel className="relative flex max-h-[90dvh] w-full max-w-md flex-col overflow-hidden rounded-t-[1.25rem] bg-secondary shadow-2xl sm:max-h-[85dvh] sm:rounded-2xl">
            <div className="shrink-0 border-b border-black/[0.06] bg-secondary/85 backdrop-blur-xl dark:border-white/[0.08]">
              <div className="flex items-center justify-between px-3 py-3">
                <button
                  type="button"
                  aria-label="Close"
                  onClick={handleCloseModal}
                  className="grid h-9 w-9 place-content-center rounded-full bg-black/[0.06] text-darkText transition active:scale-95 dark:bg-white/10"
                >
                  <IoClose className="text-xl" />
                </button>
                <DialogTitle className="max-w-[14rem] truncate text-center text-[17px] font-semibold tracking-tight text-darkText">
                  <TextTranslate text="Add Member" />
                </DialogTitle>
                <div className="h-9 w-9" aria-hidden />
              </div>

              <div className="px-4 pb-3">
                <div className="relative">
                  <IoSearchOutline className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-lg text-lightText" />
                  <input
                    value={searchUser}
                    onChange={(e) => setsearchUser(e.target.value)}
                    className="w-full rounded-[10px] border-0 bg-black/[0.06] py-2.5 pl-10 pr-10 text-[15px] text-darkText outline-none placeholder:text-lightText dark:bg-white/[0.1]"
                    type="search"
                    enterKeyHint="search"
                    placeholder={translate("Search User")}
                  />
                  {searchUser.length > 0 && (
                    <button
                      type="button"
                      aria-label="Clear"
                      onClick={() => setsearchUser("")}
                      className="absolute right-3 top-1/2 -translate-y-1/2 text-lightText"
                    >
                      <RxCross2 className="text-lg" />
                    </button>
                  )}
                </div>
              </div>
            </div>

            <div
              className={`min-h-0 flex-1 overflow-y-auto px-4 pt-3 ${
                selectedCount > 0 ? "pb-28" : "pb-6"
              }`}
            >
              <AddMemberContactList searchUser={searchUser} />
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

export default AddMemberModal;
